module.exports = __webpack_public_path__ + "img/arrow-right-purple.f9b6a8a6.svg";